var render = function render(){var _vm=this,_c=_vm._self._c;return _c('CustomerDashboardComponent',{attrs:{"customerid":this.$route.params.customerid}})
}
var staticRenderFns = []

export { render, staticRenderFns }